/* Nisha Nashea Ombré Brow Academy — Theme JS */
(function () {
  'use strict';

  // ── Navbar scroll effect ──────────────────────────────────────
  var nav = document.getElementById('nn-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 40) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  // ── Mobile menu toggle ────────────────────────────────────────
  var hamburger = document.getElementById('nn-hamburger');
  var mobileMenu = document.getElementById('nn-mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
      });
    });
  }

  // ── FAQ accordion ─────────────────────────────────────────────
  document.querySelectorAll('.nn-faq').forEach(function (faq) {
    faq.addEventListener('click', function () {
      var isOpen = faq.classList.contains('open');
      document.querySelectorAll('.nn-faq').forEach(function (f) { f.classList.remove('open'); });
      if (!isOpen) faq.classList.add('open');
    });
  });

  // ── Scroll reveal ─────────────────────────────────────────────
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

  document.querySelectorAll('.reveal').forEach(function (el) {
    observer.observe(el);
  });

})();
